export const BUTTON_IDS = {
    TOP_NAV: {
        HOME_PAGE_LOGO: "Nav - homepage_logo",
        GO_MOBILE: "Nav - Go Mobile",
        GO_BROADBAND: "Nav - Go Broadband",
        ABOUT_GOMO: "Nav - About Gomo",
        NEED_HELP: "Nav - Need Help?",
        MY_GOMO: "Nav - MyGomo",
        LOGIN: "Nav - Login",
        LOGOUT: "Nav - Logout",
        CART_ICON: "Cart Icon",
    },
};
